export default __webpack_public_path__ + "static/media/stake.cc3b40a3.svg";